// extracted by mini-css-extract-plugin
export var textInput = "_j0-0";